'use strict';

exports.__esModule = true;
exports.StyledDropDown = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n\n  .Dropdown-control {\n    overflow: hidden;\n    background-color: transparent;\n    border-radius: ', ';\n    cursor: default;\n    ', '\n    transition: all 200ms ease;\n    border: 1px solid\n      ', ';\n    padding: ', ';\n    color: ', ';\n    font-weight: ', ';\n  }\n\n  .Dropdown-placeholder {\n    white-space: nowrap;\n    &:not(.is-selected) {\n      color: ', ';\n    }\n  }\n\n  .Dropdown-arrow-wrapper {\n    position: absolute;\n    right: 10px;\n    top: 17px;\n  }\n\n  .Dropdown-menu {\n    background-color: ', ';\n    border: 1px solid ', ';\n    //box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n    border-radius: ', ';\n    margin-top: -1px;\n    max-height: 200px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    position: absolute;\n    top: 100%;\n    width: 100%;\n    z-index: 1000;\n    -webkit-overflow-scrolling: touch;\n    ', '\n  }\n\n  .Dropdown-menu .Dropdown-group > .Dropdown-title {\n    padding: ', ';\n    text-transform: capitalize;\n  }\n\n  .Dropdown-option {\n    cursor: pointer;\n    display: block;\n    padding: ', ';\n    white-space: nowrap;\n  }\n\n  .Dropdown-option:hover {\n    background-color: ', ';\n  }\n\n  .Dropdown-option.is-selected {\n    background-color: ', ';\n  }\n\n  .Dropdown-noresults {\n    box-sizing: border-box;\n    color: #ccc;\n    cursor: default;\n    display: block;\n    padding: ', ';\n  }\n'], ['\n  position: relative;\n\n  .Dropdown-control {\n    overflow: hidden;\n    background-color: transparent;\n    border-radius: ', ';\n    cursor: default;\n    ', '\n    transition: all 200ms ease;\n    border: 1px solid\n      ', ';\n    padding: ', ';\n    color: ', ';\n    font-weight: ', ';\n  }\n\n  .Dropdown-placeholder {\n    white-space: nowrap;\n    &:not(.is-selected) {\n      color: ', ';\n    }\n  }\n\n  .Dropdown-arrow-wrapper {\n    position: absolute;\n    right: 10px;\n    top: 17px;\n  }\n\n  .Dropdown-menu {\n    background-color: ', ';\n    border: 1px solid ', ';\n    //box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n    border-radius: ', ';\n    margin-top: -1px;\n    max-height: 200px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    position: absolute;\n    top: 100%;\n    width: 100%;\n    z-index: 1000;\n    -webkit-overflow-scrolling: touch;\n    ', '\n  }\n\n  .Dropdown-menu .Dropdown-group > .Dropdown-title {\n    padding: ', ';\n    text-transform: capitalize;\n  }\n\n  .Dropdown-option {\n    cursor: pointer;\n    display: block;\n    padding: ', ';\n    white-space: nowrap;\n  }\n\n  .Dropdown-option:hover {\n    background-color: ', ';\n  }\n\n  .Dropdown-option.is-selected {\n    background-color: ', ';\n  }\n\n  .Dropdown-noresults {\n    box-sizing: border-box;\n    color: #ccc;\n    cursor: default;\n    display: block;\n    padding: ', ';\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactDropdown = require('react-dropdown');

var _reactDropdown2 = _interopRequireDefault(_reactDropdown);

var _scrollbar = require('../../../styles/scrollbar');

var _scrollbar2 = _interopRequireDefault(_scrollbar);

var _focusRing = require('../../ui/tokens/focusRing');

var _spacing = require('../../../styles/spacing');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var StyledDropDown = exports.StyledDropDown = (0, _styledComponents2.default)(_reactDropdown2.default)(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.radiusSm || theme.borderRadiusDefault;
}, _focusRing.focusRingVisible, function (_ref2) {
  var theme = _ref2.theme,
      invalid = _ref2.invalid;
  return invalid ? theme.errorColor : theme.borderColor;
}, (0, _spacing.space)(15, 25, 15, 10), function (_ref3) {
  var theme = _ref3.theme,
      invalid = _ref3.invalid;
  return invalid ? theme.errorColor : theme.textColor69;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeightMedium;
}, function (_ref5) {
  var theme = _ref5.theme,
      invalid = _ref5.invalid;
  return invalid ? theme.errorColor : theme.textColor9D;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.white;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.borderColor;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.radiusSm || theme.borderRadiusDefault;
}, _scrollbar2.default, (0, _spacing.space)(8, 10), (0, _spacing.space)(7, 15, 5, 15), function (_ref9) {
  var theme = _ref9.theme;
  return theme.grayE6;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.grayE6;
}, (0, _spacing.space)(8, 10));